import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Invoice } from '@savvy/view-definition';
import { ContextIdDto } from '@savvy/quickbooks';
import { EventBusService } from '../element/EventBusService';

@Component({
  selector: 'app-request-payment-dialog',
  templateUrl: 'requestPaymentDialog.component.html'
})
export class RequestPaymentDialogComponent implements OnInit {
  invoice: Invoice;
  contextIdDto: ContextIdDto;
  eventBus: EventBusService;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RequestPaymentDialogComponent>) {
    this.contextIdDto = data.contextIdDto;
    this.invoice = data.invoice;
    this.eventBus = data.eventBus;
  }

  ngOnInit(): void {
  }
}
